export const LOGGED_IN_WITH_MAGIC_LINK = 'logged-in-with-magic-link'

export const COMPOUND_SPECIALITIES = [
  'EDUCADOR_FISICO',
  'ASSISTENTE_SOCIAL',
  'HEALTH_COACH',
  'TECNICO_RADIOLOGIA',
]

export const REDIRECT_PATTERNS = [
  'atendimento-agendado/categoria/',
  'atendimento-agendado/preferencia/busca-profissional/',
  'atendimento-agendado/especialidade/encaixe/',
  'atendimento-agendado/categoria/medico/',
  'atendimento-agendado-psicologo/busca-profissional/perfil-profissional/',
  'atendimento-agendado/preferencia/',
  'atendimento-agendado/',
]
